//Modal Change Address
export const MODAL_CHANGE_ADDRESS_CHANGE_SHOW = 'MODAL_CHANGE_ADDRESS_CHANGE_SHOW';
export const MODAL_CHANGE_ADDRESS_CHANGE_LOADER = 'MODAL_CHANGE_ADDRESS_CHANGE_LOADER';

//Modal Shopping Card
export const OPEN_MODAL_SHOPPING_CARD = 'OPEN_MODAL_SHOPPING_CARD';
export const CLOSE_MODAL_SHOPPING_CARD = 'CLOSE_MODAL_SHOPPING_CARD';
export const TOGGLE_ANIMATION_MODAL_SHOPPING_CARD = 'TOGGLE_ANIMATION_MODAL_SHOPPING_CARD';
export const TOGGLE_ARROW_MODAL_SHOPPING_CARD = 'TOGGLE_ARROW_MODAL_SHOPPING_CARD';
export const CHANGE_LEVEL_PAYMENT_SHOPPING_CARD = 'CHANGE_LEVEL_PAYMENT_SHOPPING_CARD';
export const ADD_ITEM_IN_SHOPPING_CART = 'ADD_ITEM_IN_SHOPPING_CART';
export const CHANGE_LOADER_LIST_PRODUCTS_MODAL_SHOPPING_CARD = 'CHANGE_LOADER_LIST_PRODUCTS_MODAL_SHOPPING_CARD';
export const CHANGE_API_CARDS_LIST_PRODUCTS_MODAL_SHOPPING_CARD = 'CHANGE_API_CARDS_LIST_PRODUCTS_MODAL_SHOPPING_CARD';
export const REMOVE_ALL_ITEM_IN_BASKET_CART = 'REMOVE_ALL_ITEM_IN_BASKET_CART';
export const REMOVE_ITEM_IN_BASKET_CART = 'REMOVE_ITEM_IN_BASKET_CART';
export const CHANGE_DAYS_SELECT_MODAL_SHOPPING_CARD = 'CHANGE_DAYS_SELECT_MODAL_SHOPPING_CARD';
export const CHANGE_ACTIVE_DAY_POST_SCHEDULE = 'CHANGE_ACTIVE_DAY_POST_SCHEDULE';
export const CHANGE_ACTIVE_SELECT_TABLE_POST_SCHEDULE = 'CHANGE_ACTIVE_SELECT_TABLE_POST_SCHEDULE';
export const CHANGE_LIST_QUESTIONS = 'CHANGE_LIST_QUESTIONS';
export const REFRESH_MODAL_SHOPPING_CARD = 'REFRESH_MODAL_SHOPPING_CARD';
export const CHANGE_INPUTS_MODAL_SHOPPING_CARD = 'CHANGE_INPUTS_MODAL_SHOPPING_CARD';
export const CHANGE_SELECTABLE_ITEM_QUESTION_MODAL_SHOPPING_CARD = 'CHANGE_SELECTABLE_ITEM_QUESTION_MODAL_SHOPPING_CARD';
export const HANDEL_CHANGE_INVOICE_MODAL_SHOPPING_CARD = 'HANDEL_CHANGE_INVOICE_MODAL_SHOPPING_CARD';
export const HANDEL_CHANGE_LOADER_PRICE_INVOICE = 'HANDEL_CHANGE_LOADER_PRICE_INVOICE';
export const CHANGE_PAY_TYPE_CLICK_INVOICE = 'CHANGE_PAY_TYPE_CLICK_INVOICE';
export const ADD_ITEM_IN_INVOICE = 'ADD_ITEM_IN_INVOICE';
export const REMOVE_ITEM_IN_INVOICE = 'REMOVE_ITEM_IN_INVOICE';

//
export const ADDRESS_REMOVE_ITEM_ADDRESS = 'ADDRESS_REMOVE_ITEM_ADDRESS';

